// @module C3.ShoppingExtensions.ManufacturerPage
define('C3.ShoppingExtensions.SubCategory.Circles.View'
,	[
	'c3_shoppingextensions_subcategory_circles.tpl'
	
	,	'SCView'
	//,   'C3.ShoppingExtensions.Carousel.View'
	,   'AjaxRequestsKiller'
	//,	'Backbone'
	,   'GlobalViews.Breadcrumb.View'
	,   'Utils'
	,   'Backbone.CollectionView'
	,   'Facets.CategoryCell.View'
    ]
, function (
	c3_shoppingextensions_subcategory_circles_tpl
	
	,	SCViewModule
	//,   CarouselView
	,   AjaxRequestsKiller
	//,	Backbone
	,   GlobalViewsBreadcrumbView
	,   Utils
	,   BackboneCollectionView
	,   FacetsCategoryCellView
)
{
    'use strict';

    var SCView = SCViewModule.SCView;

     function SubCategoryCirclesPageView (options) {
     	SCView.call(this, options);

     	this.template = c3_shoppingextensions_subcategory_circles_tpl;
        this.options = options;
	   this.application = options.application;
	   this.model = options.model;
	  // console.log(options)
     }

     SubCategoryCirclesPageView.prototype = Object.create(SCView.prototype);
     SubCategoryCirclesPageView.prototype.constructor = SubCategoryCirclesPageView;


     SubCategoryCirclesPageView.prototype.render = function () {
    	SCView.prototype.render.call(this);
    	
    }

    SubCategoryCirclesPageView.prototype.getContext = function () {

    			var catModel = this.model;
    			
    			var categoryWiseItemsObject = (typeof localStorage !== 'undefined') ? JSON.parse(localStorage.getItem('CategoryWiseItemsCount')) : null
    			
    			var catItemCountObject= _.find(categoryWiseItemsObject, function(category) {
					return category.categoryId === catModel.get('internalid');
				})|| {};
									
				var catItemCount = (catItemCountObject && catItemCountObject.itemCount != null)
					  ? " (" + catItemCountObject.itemCount + ")"
				: "";

    	return {
				thumbnailURL : this.model.get('thumbnailurl'),
				fullURL : this.model.get('fullurl'),
				name :  this.model.get('name'),
				catItemCount : catItemCount
			};
    }

     return SubCategoryCirclesPageView;

});
